var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnFirstNextDisable = function SvgBtnFirstNextDisable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0s28 12.536 28 28-12.536 28-28 28S0 43.464 0 28Z",
    fill: "#DDDEE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.985 36.485 38.471 28l-8.486-8.485M38 28H18",
    stroke: "#F5F5F5",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
};
export default SvgBtnFirstNextDisable;